// extracted by mini-css-extract-plugin
var _1 = "ListItem-modulelistItem__WzcC4 TextMultiValuedListItem-moduleTextMultiValuedListItem__EdyG9 MultiValuedListItem-moduleMultiValuedListItem__IhIDF";
export { _1 as "listItem" }
